export default __webpack_public_path__ + "static/media/default.f9b68477b4d60a73c3153ee077abb8e1.png";